export default {
    GET_ALL_ACCOUNTS: 'GET_ALL_ACCOUNTS',
    ADD_ACCOUNTS: 'ADD_ACCOUNTS',
    UPDATE_ACCOUNTS: 'UPDATE_ACCOUNTS',
    CHANGE_PASSWORD_ACCOUNTS: 'CHANGE_PASSWORD_ACCOUNTS',
    CHANGE_ACTIVATION: 'CHANGE_ACTIVATION',
    DELETE_ACCOUNTS: 'DELETE_ACCOUNTS',
}